export default __webpack_public_path__ + "caret-arrow-up.png";